enum Signal {
  draft = 'draft',
  recentUsers = 'recentUsers',
  extension = 'extension'
}

const funcs: Record<string, CallableFunction[]> = {}

const setOn = (key: string, func: CallableFunction) => {
  if (!(key in funcs)) {
    funcs[key] = []
  }

  funcs[key].push(func)
}

const setOff = (key: string, func: CallableFunction) => {
  if (!(key in funcs)) {
    return
  }

  funcs[key] = funcs[key].filter(f => f !== func)
}

const callSignal = (key: string, ...args: any[]) => {
  if (!(key in funcs)) {
    return
  }

  funcs[key].forEach(func => func(...args))
}

const signal = {
  on: setOn,
  off: setOff,
  signal: callSignal
}

declare global {
  interface Window {
    SONAR_SIGNAL: typeof signal
  }
}

window.SONAR_SIGNAL = signal

export default Signal
